import vzanSubscripe from './index.vue'
export default {
  install(Vue) {
    Vue.component('vzan-subscribe', vzanSubscripe)
  }
}
